export const getParticipantDetailsQuery = `
query getParticipantDetails($participantId: String!) {
  getParticipantDetails(participantId: $participantId) {
    firstName
    surname
    dob
    nhsNumber
    participantId
    participantRef
    sexAtBirth
    participantStatus
    sampleBarcode
  }
}`;
